import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
} from '@airbus/components-react';
import styles from './BulkUpdateConfirmDialog.module.css';
import Spinners from '../Spinner';

type BulkUpdateConfirmDialogProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  quitLabel: string;
  isSubmitting?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export default function BulkUpdateConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  quitLabel,
  isSubmitting = false,
  onConfirm,
  onClose,
}: BulkUpdateConfirmDialogProps) {
  const handleDialogClose = () => {
    if (isSubmitting) return;
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} test-id='bulk-update-confirm-dialog'>
      <div>
        <DialogHeader>{title}</DialogHeader>
        <DialogContent>
          <p className={styles.warningMessage}>{message}</p>
        </DialogContent>
        <DialogActions>
          <Button variant='secondary' onClick={handleDialogClose} disabled={isSubmitting}>
            {quitLabel}
          </Button>
          <Button variant='primary' onClick={onConfirm} disabled={isSubmitting}>
            {confirmLabel}
          </Button>
        </DialogActions>

        {isSubmitting && (
          <div className={styles.loadingOverlay} role='status' aria-live='polite'>
            <Spinners />
          </div>
        )}
      </div>
    </Dialog>
  );
}
